import { createFileRoute } from "@tanstack/react-router"
import { Plus } from "@phosphor-icons/react"
import { Module, OverviewPage } from "~/components/design-system/pages"
import { Badge, Button } from "~/components/design-system/components"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import NotFound from "~/components/reusable/NotFound"
import { useFlags } from "~/features/feature-flags"
import FiscalYearBudgetList from "~/components/budget/FiscalYearBudgetList"
import CreateFiscalYearTargetDrawer from "~/components/budget/CreateFiscalYearTargetDrawer"
import BudgetTimelineSettingsDialog from "~/components/budget/timeline/BudgetTimelineSettingsDialog"

export const Route = createFileRoute("/_auth/budgets/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { budget: budgetFlag } = useFlags()
  if (budgetFlag === false) return <NotFound />

  return (
    <Module
      breadcrumb={
        <>
          <BreadcrumbWrapper items={[{ label: "Budgets" }]} />
          <Badge size="sm" variant="violet">
            Beta
          </Badge>
        </>
      }
      actions={
        <>
          <BudgetTimelineSettingsDialog />
          <CreateFiscalYearTargetDrawer
            trigger={
              <Button size="sm">
                <Plus /> Create fiscal year budget
              </Button>
            }
          />
        </>
      }
    >
      <OverviewPage>
        <FiscalYearBudgetList />
      </OverviewPage>
    </Module>
  )
}
